import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import {
  CalendarDays,
  ClipboardList,
  Ticket,
  History,
  Star,
  CalendarCheck,
  BookOpen,
  FileText,
} from 'lucide-react';
import ClubInfo from '../components/ClubInfo';
import { useHome } from '../hooks/useHome';
import AdvertisementComponent from '@/components/AdvertisementComponent';
import { AdvertisementSkeleton } from '@/components/AdvertisementSkeleton';
import WelcomeMessageComponent from '@/components/WelcomeMessageComponent';

const Home: React.FC = () => {
  const { advertisement, selectedClubValue, updateDataFilial, setSelectedClubValue, userName } =
    useHome();

  const menuCards = [
    {
      icon: <ClipboardList className="w-6 h-6" />,
      title: 'Мои занятия',
      description: 'Просмотр ваших текущих и предстоящих занятий',
      link: '/classes',
      buttonText: 'Перейти к занятиям',
    },
    {
      icon: <CalendarDays className="w-6 h-6" />,
      title: 'Расписание',
      description: 'Просмотр доступных занятий и запись на тренировки',
      link: '/sign-up',
      buttonText: 'Перейти к расписанию',
    },
    {
      icon: <Ticket className="w-6 h-6" />,
      title: 'Абонементы',
      description: 'Информация о ваших активных абонементах',
      link: '/tickets',
      buttonText: 'Перейти к абонементам',
    },
    {
      icon: <History className="w-6 h-6" />,
      title: 'Последние оплаты',
      description: 'История ваших платежей и операций',
      link: '/purchase_history',
      buttonText: 'Посмотреть историю',
    },
    {
      icon: <Star className="w-6 h-6" />,
      title: 'Бонусный счет',
      description: 'Ваши накопленные бонусы и привилегии',
      link: '/bonuses',
      buttonText: 'Проверить бонусы',
    },
    {
      icon: <CalendarCheck className="w-6 h-6" />,
      title: 'История посещений',
      description: 'Статистика ваших посещений занятий',
      link: '/visits_history',
      buttonText: 'Посмотреть историю',
    },
    {
      icon: <BookOpen className="w-6 h-6" />,
      title: 'Дневник пловца',
      description: 'Отслеживание прогресса и достижений',
      link: '/achievements',
      buttonText: 'Открыть дневник',
    },
    {
      icon: <FileText className="w-6 h-6" />,
      title: 'Справки',
      description: 'Управление медицинскими справками',
      link: '/certificates',
      buttonText: 'Перейти к справкам',
    },
  ];

  return (
    <div className="px-4 pb-6 space-y-6 mt-20">
      <div className="bg-white rounded-lg">
        <WelcomeMessageComponent userName={userName} />
        {advertisement ? <AdvertisementComponent /> : <AdvertisementSkeleton />}

        <div className="grid grid-cols-1 gap-6 md:hidden max-w-full overflow-hidden">
          {menuCards.map((card) => (
            <Link key={card.link} to={card.link} className="h-full">
              <div className="h-full group">
                <div className="h-full p-6 transition-all duration-200 bg-white border rounded-lg hover:border-primary hover:shadow-md">
                  <div className="flex items-center gap-4 mb-4">
                    <div className="p-3 rounded-lg bg-primary/10 text-primary">{card.icon}</div>
                    <h2 className="text-xl font-medium text-gray-900">{card.title}</h2>
                  </div>
                  <p className="mb-4 text-gray-600">{card.description}</p>
                  <Button
                    variant="outline"
                    className="w-full bg-[#4ab0dd] text-white hover:bg-[#4ab0dd] hover:text-white">
                    {card.buttonText}
                  </Button>
                </div>
              </div>
            </Link>
          ))}
        </div>
        <ClubInfo />
      </div>
    </div>
  );
};

export default Home;
